/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var setReadOnly = require( '@stdlib/utils-define-read-only-property' );
var objectKeys = require( '@stdlib/utils-keys' );


// MAIN //

/**
* Copies all enumerable own properties from a source object to a target object as enumerable read-only properties.
*
* @private
* @param {Object} target - target object
* @param {Object} source - source object
* @returns {Object} modified target object
*
* @example
* var source = {
*     'beep': 'boop'
* };
* var target = {};
*
* var out = assign( target, source );
* // returns <Object>
*
* var bool = ( out === target );
* // returns true
*
* var v = target.beep;
* // returns 'boop'
*/
function assign( target, source ) {
	var keys;
	var k;
	var i;

	keys = objectKeys( source );
	for ( i = 0; i < keys.length; i++ ) {
		k = keys[ i ];
		setReadOnly( target, k, source[ k ] );
	}
	return target;
}


// EXPORTS //

module.exports = assign;
